import {
  Component,
  DoCheck,
  HostBinding,
  Input,
  OnInit,
  SimpleChanges,
  inject
} from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { ToggleQuestionV3 } from '../../../classes/question-toggle';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'bepatient-input-toggle-v3',
  templateUrl: './input-toggle.component.html',
  styleUrls: ['./input-toggle.component.scss'],
  standalone: false
})
export class InputToggleComponentV3
  extends QuestionBaseV3ComponentDirective
  implements DoCheck
{
  private sanitizer = inject(DomSanitizer);

  @Input() question: ToggleQuestionV3;
  @Input() color: string;
  dirty: boolean;

  @HostBinding('attr.style')
  get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(
      `--data-color-checked: ${this.color}; --data-color-checked-track: ${this.color}60`
    );
  }

  get options() {
    const formArray = this.formGroup.get(this.question.key) as UntypedFormArray;
    return formArray.controls;
  }

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.formGroup.currentValue && this.question) {
      /*
          By default, empty values are string ""
          those strings are interpreted as value by the template.
          Hence toggle are checked.

          That's the reason why we change these strings to
          booleans
        */

      const parsedValue = this.formGroup
        .get(this.question.key)
        .value.map(v => !!v);

      this.formGroup.patchValue(
        { [this.question.key]: parsedValue },
        { emitEvent: false }
      );
    }
  }

  isChecked(): void {
    this.formGroup.get(this.question.key).markAsTouched();
    this.dirty = this.formGroup.get(this.question.key).dirty;
    setTimeout(() => {
      const parsedValue = this.formGroup
        .get(this.question.key)
        .value.map(v => !!v);

      this.formGroup.patchValue({ [this.question.key]: parsedValue });
    }, 0);
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }
}
